export const classes = {
  listItem:
    'flex items-center pl-4 pr-6 py-2 text-grey-7 bg-white hover:bg-grey-1 cursor-pointer select-none rounded-xl mx-2 my-1',
  icon: 'pr-3 text-grey-7',
};
